import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { confirmAlert } from 'react-confirm-alert';
import { Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import moment from 'moment/min/moment-with-locales';

//components
import applicationRouter from '../../hoc/applicationRouter.js';
import SwitchWidget from '../../containers/Admin/ControlPanel/SwitchWidget';
import { Accordion, AccordionItem } from '../Accordion/Accordion';
import withLocalization from '../../hoc/withLocalization.js';
import PayrollHistoryTable from './PayrollHistoryTable.js';
import MedicalLeaveSyncTable from './MedicalLeaveSyncTable.js';
import UserPromptModal from './userPromptModal/index.js';

//elements
import Button from '../../components/CustomButton/CustomButton.jsx'
import LoadingSpinner from '../../elements/LoadingSpinner';
import { Textarea } from '../../elements/Input';
import { Table } from 'react-bootstrap';

//utils
import { shortDateFormat } from '../../utils/dateFormat';
import { minutesToTimeInput } from '../../utils/timeCalc.js';
import { getCompanyShiftDetails } from '../../utils/commonMethods.js';
import { getShiftTotalHoursInMins } from '../../utils/scheduleUtils.js';
import { _dayMap } from '../../utils/commonMethods.js';
import { payrollIntegrationOptions, TIMESHEET_CONSTANT } from '../../utils/constants.js';

//assets
import ResetApprovalIcon from '../../assets/img/resetApprovalIcon.svg';
import ApprovalIcon from '../../assets/img/ApprovalIcon.svg';
import RejectIcon from '../../assets/img/RejectIcon.svg';

class AbsenceVacationApproval extends Component {
    constructor(props) {
        super(props);
        this.currentIntegrationProduct = props.commonStore?.config?.integration_details?.product || null;
        this.syncAdditionalPaymentsWithAbsence = props.commonStore.config?.integration_details?.integration_settings?.syncAdditionalPaymentsWithAbsence || false

        this.state = {
            notes: '',
            validationMessage: '',
            syncWithIntegration: false,
            isAlreadySynced: false,
            currentStatus: 'active',
            shiftDetails: [],
            isLoading: true,
            addedExtraPayment: false,
            absenceExtraPaymentData: null,
            showMore: false,
            userDetail: null,
            employement_grade: 100,
            totalAbsenceHours: 0,
            integrationData: null,
            integrationStatus: null,
            hasHolidays: false,
            start_time: null,
            end_time: null,
            integrationHistory: [],
            entityUserId: null,
            absenceType: null,
            medicalLeaveSyncPreview: null,
            medicalLeaveSyncResult: null,
            defaultHolidaysExcluded: false,
            userPromptModal: { source: null, header: '', showModal: false, sourceInfo: {}, actionMethods: {} },
        }
    }

    componentDidMount() {
        this.loadData();
    }

    getDateTimeRules = () => {
        const { commonStore } = this.props;
        return commonStore.getDateTimeRules();
    }

    getShiftDetails = async (start, end, userId, entityTypeAbsence, entityId) => {
        const dateTimeRules = this.getDateTimeRules();
        const { commonStore, scheduleStore, t } = this.props;
        try {
            const paramsObj = {
                start: start,
                end: end,
                userID: userId,
                entityTypeAbsence: entityTypeAbsence,
                entityId: entityId
            }
            const shiftsDetails = await scheduleStore.loadShiftsForApproval(paramsObj, dateTimeRules);
            return shiftsDetails.shifts;
        } catch (err) {
            console.error({ err })
            commonStore.addNotification(t(typeof err === 'string' ? err : 'Something went wrong'), null, 'error');
        }
    }

    getExtraPaymentDetails = (paymentAbsenceExtra, wageTypeCategories, absenceExtraPaymentData) => {
        const result = paymentAbsenceExtra
            .map(entry => {
                if (!entry?.internal_id) return null;

                const [shiftId, wageCode] = entry.internal_id.split(',');
                const shiftData = absenceExtraPaymentData[shiftId];
                let extraPaymentName = '';
                let extraPaymentCode = '';


                if (shiftData && shiftData.extraPayments) {
                    const matchingPayment = Object.values(shiftData.extraPayments).find(
                        payment => payment.payrollWageType.value === wageCode
                    );

                    if (matchingPayment) {
                        extraPaymentName = matchingPayment.name;
                        extraPaymentCode = matchingPayment.code;
                    }
                }

                return {
                    id: entry.id,
                    shiftId,
                    wageCode,
                    wageTypeDisplayName: extraPaymentName,
                    extraPaymentName,
                    extraPaymentCode,
                    status: entry.status,
                    errorMessages: entry.status === 'failed'
                        ? entry.data && entry.data.messages?.map(m => m.message) || []
                        : [],
                    absenceId: entry.absence_id,
                    payrollId: entry.payroll_id,
                    forDate: shiftData.forDate
                };
            })
            .filter(item => item !== null);
        return result.length > 0 ? result : null;
    };

    getUniqueExtraPaymentsCodes(shiftDetails) {
        const uniqueCodes = new Set();
        shiftDetails.forEach(shift => {
            if (shift.extraPayments) {
                Object.values(shift.extraPayments).forEach(payment => {
                    uniqueCodes.add(payment.code);
                });
            }
        });
        return Array.from(uniqueCodes);
    }

    async loadData() {
        const { absenceStore, timelogStore, params, vacationStore, t, commonStore } = this.props;
        const isIntegrationAvailable = !!this.currentIntegrationProduct;
        if (params.entity === 'absence' || params.entity === 'vacation') {
            const entityType = params.entity;
            const storeMap = {
                'absence': absenceStore,
                'vacation': vacationStore
            };
            const store = storeMap[entityType];
            const entity = await store.load(this.props.params.ids[0]);
            const entityData = entity[entityType];
            entityData['model_name'] = entityType;
            const unpaidTypeMap = {
                'absence': 'unpaid'
            };
            const isAlreadySynced = isIntegrationAvailable &&
                ((entityData.int_id && entityData.int_status === 'success') || entityData.int_status === 'failed');
            let validationMsg = '';
            if (entityType === 'absence' && entityData.leave_type === unpaidTypeMap[entityType]) {
                validationMsg = "Unable to send Unpaid Absence to the payroll system";
            }
            let shiftDetails = [];
            let hasHolidays = false;
            if (parseInt(params.count) === 1) {
                const entityTypeAbsence = entityType === 'absence' ? true : false;
                const allShifts = await this.getShiftDetails(entityData.from, entityData.to, entityData.user_id, entityTypeAbsence, entityData.id);
                shiftDetails = allShifts.filter(shift => {
                    const date = moment(shift.forDate);
                    const isHoliday = this.checkIfDayIsHoliday(date, entityType);
                    if (isHoliday) {
                        hasHolidays = true;
                        return false;
                    }
                    return true;
                });
            }
            if (isIntegrationAvailable && !validationMsg) {
                let uniqueCodes = [];
                if (shiftDetails?.length && shiftDetails.some((shift) => shift.extraPayments && Object.keys(shift.extraPayments).length > 0)) {
                    uniqueCodes = this.getUniqueExtraPaymentsCodes(shiftDetails);
                    if (uniqueCodes.length > 0) entityData.extraPaymentCodes = uniqueCodes;
                }
                validationMsg = await timelogStore.validateTimelogWithIntegration(entityData);
            }
            const stateUpdate = {
                notes: entityData.status_note,
                validationMessage: t(validationMsg),
                syncWithIntegration: isAlreadySynced || (isIntegrationAvailable && !validationMsg),
                isAlreadySynced: isAlreadySynced,
                currentStatus: entityData.status,
                shiftDetails,
                hasHolidays,
                integrationHistory: entityData.data?.integrationSyncHistory || [],
                entityUserId: entityData.user_id
            };
            if (entityType === 'absence' || entityType === 'vacation') {
                if (entityType === 'absence') {
                    if (shiftDetails.length && shiftDetails.some((shift) => shift.extraPayments && Object.keys(shift.extraPayments).length > 0) && this.syncAdditionalPaymentsWithAbsence && this.currentIntegrationProduct !== payrollIntegrationOptions.XLEDGER && !validationMsg) {
                        stateUpdate.addedExtraPayment = true;
                    }
                    stateUpdate.employement_grade = entityData.employement_grade;
                    const currentIntegrationWageType = commonStore?.config?.integration_details?.wageType ? commonStore?.config?.integration_details?.wageType : null;
                    const absenceExtraPaymentData = entityData.data?.extraPaymentsData && Object.keys(entityData.data?.extraPaymentsData).length > 0 ? entityData.data.extraPaymentsData : null;
                    const absenceIntegrationData = entityData?.payrollAbsenceExtra || null;
                    if (currentIntegrationWageType && absenceIntegrationData && absenceExtraPaymentData) {
                        const response = this.getExtraPaymentDetails(absenceIntegrationData, currentIntegrationWageType, absenceExtraPaymentData);
                        if (response && response.length > 0) stateUpdate.absenceExtraPaymentData = response;
                    }
                    stateUpdate.totalAbsenceHours = entityData.total_days * entityData.hours;
                    stateUpdate.start_time = entityData.start_time || 0;
                    stateUpdate.end_time = entityData.end_time || 0;
                }
                stateUpdate.userDetail = entityData.User;
                if (entityData.int_data) stateUpdate.integrationData = entityData.int_data;
                if (entityData.int_status) stateUpdate.integrationStatus = entityData.int_status;
                stateUpdate.start_time = entityData.start_time || 0;
                stateUpdate.end_time = entityData.end_time || 0;
                stateUpdate.absenceType = entityData.absence_type;
                if (entityData.medicalLeaveSyncPreview) stateUpdate.medicalLeaveSyncPreview = entityData.medicalLeaveSyncPreview;
                if (entityData.medicalLeaveSyncResult) stateUpdate.medicalLeaveSyncResult = entityData.medicalLeaveSyncResult;
                stateUpdate.defaultHolidaysExcluded = !!entityData.defaultHolidaysExcluded;
            }
            this.setState(stateUpdate, () => this.setState({ isLoading: false }));
            return;
        }
        else if (params.entity === 'timelog') {
            const entityType = params.entity;
            const entity = await timelogStore.load(this.props.params.ids[0]);
            const entityData = entity[entityType];
            entityData['model_name'] = entityType;

            const isAlreadySynced = isIntegrationAvailable &&
                ((entityData.int_id && entityData.int_status === 'success') || entityData.int_status === 'failed');
            let validationMsg = '';
            if (isIntegrationAvailable) {
                validationMsg = await timelogStore.validateTimelogWithIntegration(entityData);
            }
            const stateUpdate = {
                notes: entityData.status_note || '',
                validationMessage: t(validationMsg),
                syncWithIntegration: isAlreadySynced || (isIntegrationAvailable && !validationMsg),
                isAlreadySynced: isAlreadySynced,
                currentStatus: entityData.status,
                entityUserId: entityData.user_id
            };
            this.setState(stateUpdate, () => this.setState({ isLoading: false }));
        }
        else {
            this.setState({ isLoading: false });
        }
    }

    isStatusUpdated = () => {
        const { currentStatus } = this.state
        return currentStatus !== 'active';
    }

    async handleRun(action) {
        const { t, commonStore } = this.props;
        if (action === 'rejected' && !this.state.notes)
            return commonStore.addNotification(t('Comment is required'), null, 'error');
        const { params } = this.props;
        if (params.entity === 'absence' && action === 'approved' && this.state.shiftDetails.length && this.state.addedExtraPayment)
            await this.handleShift(action, "Do you want to include additional payments?");
        else
            await this.saveAndSetStatus(action);
    }

    handleShift = async (action, text) => {
        const { t } = this.props;
        const str = t(text)
        return confirmAlert({
            title: t('Are You Sure'),
            message: str,
            buttons: [
                {
                    label: t('Yes'),
                    onClick: async () => this.saveAndSetStatus(action, { shifts: this.state.shiftDetails })
                },
                {
                    label: t('No'),
                    onClick: () => { },
                },
            ],
        });
    }

    handleSyncSwitch = (value) => {
        this.setState({ syncWithIntegration: value })
    }


    handleExtraPaymentSwitch = (value) => {
        this.setState({ addedExtraPayment: value });
    }

    calculateAbsenceHours = (startTime, endTime, companyShiftId, employement_grade) => {
        const { config } = this.props.commonStore;
        const defaultBreakTime = config.client?.data?.basicRules?.breakTimeRules?.minutes || 0;
        const total_hours = getShiftTotalHoursInMins(startTime, endTime);
        let breakTime = 0
        let normalHours = total_hours;
        if (companyShiftId) {
            const shiftResult = getCompanyShiftDetails(config, companyShiftId, minutesToTimeInput);
            if (shiftResult && shiftResult.break) {
                breakTime = shiftResult.break;
            }
        } else {
            breakTime = defaultBreakTime || 0;
        }
        if (total_hours > TIMESHEET_CONSTANT.MINIMUM_HOURS_FOR_BREAK_IN_MIN && !breakTime) breakTime = 30;
        if (total_hours <= breakTime) breakTime = 0;
        normalHours = total_hours - breakTime;
        const totalNormalHours = Number((normalHours * (employement_grade / 100)).toFixed(2));
        return totalNormalHours;
    }

    checkIfDayIsHoliday = (date, entityType) => {
        const { commonStore } = this.props;
        const currentDate = moment(date);
        const _forDateDay = _dayMap[currentDate.day()];

        const config = commonStore.config;
        const defaultHolidays = config.client?.data?.Vacation_setup?.default_holidays_for_vacation || '';
        const enableDefaultHolidaysForAbsence = config.client?.data?.Vacation_setup?.enable_default_holidays_for_absence;

        const isDefaultHoliday =
            (entityType === 'absence' && enableDefaultHolidaysForAbsence) ||
                (entityType === 'vacation')
                ? defaultHolidays.includes(_forDateDay)
                : false;

        const holidayInfo = commonStore.getHolidayInfo(date);
        const isClientHoliday = holidayInfo.isHoliday &&
            ((entityType === 'absence' && holidayInfo.details?.accountedInAbsence) ||
                (entityType === 'vacation' && holidayInfo.details?.accountedInVacation));
        return isDefaultHoliday || isClientHoliday;
    }

    formatIntegrationErrors = (integrationData, integrationType) => {
        const { t } = this.props;
        if (!integrationData) return null;

        const errorMessage = <div>{t("Something went wrong")} ({t("from")} {integrationType})</div>;

        if (integrationType === payrollIntegrationOptions.TRIPLETEX) {
            return integrationData?.timesheet_entries?.filter(e => e.error).map(e => (
                <div key={e.date}>
                    <b>{e.date}</b>: {e.error.message}
                </div>
            )) || errorMessage;
        }

        if (integrationType === payrollIntegrationOptions.VISMA) {
            return integrationData?.messages?.length
                ? integrationData.messages.map((m, i) => <div key={i}>{m.message}</div>)
                : errorMessage;
        }

        return errorMessage;
    };

    // Resolves a wage-type label for records synced before payrollWageType was snapshotted.
    // Visma/TripleTex only store a raw code/id, so it's reverse-looked-up against the wage-type catalog;
    // if the code no longer exists in the catalog (removed since), the raw code/id is shown as a last resort.
    getFallbackWageTypeLabel = (integrationData, integrationType) => {
        const { commonStore } = this.props;
        if (integrationType === payrollIntegrationOptions.VISMA) {
            const code = integrationData?.eventcode;
            if (!code) return null;
            const match = commonStore.getAllWageTypesCombined().find(w => String(w.value) === String(code));
            return match?.label || code;
        }
        if (integrationType === payrollIntegrationOptions.TRIPLETEX) {
            const activityId = integrationData?.timesheet_entries?.[0]?.activity_id;
            if (!activityId) return null;
            const match = commonStore.getAllWageTypesCombined().find(w => String(w.value) === String(activityId));
            return match?.label || `${activityId}`;
        }
        return null;
    };

    // Unified wage-type label across all three integrations, for the compact sync-status block
    // (independent of the Xledger-specific card and the Visma/TripleTex-only fallback above).
    getWageTypeLabel = (integrationData, integrationType) => {
        if (integrationData?.payrollWageType?.label) return integrationData.payrollWageType.label;
        if (integrationType === payrollIntegrationOptions.XLEDGER) {
            return integrationData?.addTimesheets?.[0]?.activity?.description
                || integrationData?.addTimesheets?.[0]?.timeType?.description
                || null;
        }
        return this.getFallbackWageTypeLabel(integrationData, integrationType);
    };

    formatIntegrationSuccess = (integrationData, integrationType, integrationStatus) => {
        const { t } = this.props;
        if (integrationType === payrollIntegrationOptions.XLEDGER) {
            // const absences = integrationData?.addAbsence;
            // const absenceArray = Array.isArray(absences) ? absences : absences ? [absences] : [];
            return (
                <div className="bg-white border rounded shadow-sm p-3" style={{ maxWidth: "20rem" }}>
                    <div className="d-flex align-items-center mb-2">
                        <i className="fa fa-check-circle text-success me-2"></i>
                        <span className="small fw-medium text-success">{t("Absence Registered")}</span>
                    </div>

                    {integrationData?.addTimesheets?.length > 0 ? (
                        <div className="small text-muted">
                            {/* <div className="fw-semibold text-dark mb-1">{integrationData?.addTimesheets?.[0]?.employee?.description}</div> */}
                            {[
                                // { label: "Period", value: integrationData?.addTimesheets?.map((a, idx) => (<div key={idx} style={{ fontSize: '8px' }}>{a.fromDate} - {a.toDate}</div>)) },
                                // { label: "Leave Percentage", value: `${integrationData?.addTimesheets?.[0]?.leavePercent}%` },
                                { label: "Activity", value: integrationData?.addTimesheets?.[0]?.activity?.description },
                                { label: "Time Type", value: integrationData?.addTimesheets?.[0]?.timeType?.description },
                                // { label: "Code", value: integrationData?.addTimesheets?.[0]?.absenceCode?.description },
                            ].map((item, idx) => (
                                <div key={idx} className="d-flex justify-content-between">
                                    <span className="text-secondary">{t(item.label)}:</span>
                                    <span className="text-truncate fw-semibold ms-2 text-dark">{item.value}</span>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="text-muted small">{t("Absence Registered")}</div>
                    )}
                </div>
            );
        } else {
            const wageTypeLabel = integrationData?.payrollWageType?.label || this.getFallbackWageTypeLabel(integrationData, integrationType);
            const isActivityBased = integrationType === payrollIntegrationOptions.TRIPLETEX;
            return (
                <div>
                    <div>{t("Absence Syncing Status")}: {t(integrationStatus).toUpperCase()}</div>
                    {wageTypeLabel && <div>{isActivityBased ? t('Activity') : t('Wage Type')}: {wageTypeLabel}</div>}
                </div>
            );
        }
    };

    handleExtraPaymentDisplay = (record, index) => {
        if (!record) return null;

        const isSuccess = record.status === 'success';
        const statusIcon = isSuccess ? '✓' : '✗';
        const statusClass = isSuccess ? 'text-success' : 'text-danger';
        const dateTimeRules = this.getDateTimeRules();

        return (
            <tr key={index} style={{ fontSize: '11px' }}>
                <td className="py-1 pe-3" style={{ width: '45%' }}>
                    <div className="fw-semibold text-dark mb-1">{record.wageTypeDisplayName}</div>
                    {record.forDate && (
                        <div className="text-muted" style={{ fontSize: '10px' }}>
                            {shortDateFormat(record.forDate, dateTimeRules)}
                        </div>
                    )}
                </td>
                <td className={`py-1 ${statusClass}`} style={{ width: '55%' }}>
                    <div className={`d-flex align-items-center justify-content-center`}>
                        <span className="me-2">{statusIcon}</span>
                        <span className={isSuccess ? '' : 'text-wrap'} style={{ lineHeight: '1.2' }}>
                            {isSuccess ? 'Success' : (record.errorMessages?.[0] || 'Failed')}
                        </span>
                    </div>
                </td>
            </tr>
        );
    };


    saveAndSetStatus = async (action, shiftCreationParams) => {
        const { timelogStore, params, afterSave, commonStore, t } = this.props;
        this.setState({ isLoading: true })
        let currentId = null;
        try {
            if (params.entity === 'absence' && (action === 'reset' || action === 'rejected')) {
                this.setState({ addedExtraPayment: false });
            }

            if (action === 'approved' && params.entity === 'timelog') {
                const timelogsToCheck = params.ids.map(id => timelogStore.currentList.rows.find(t => t.id === Number(id))).filter(Boolean);
                const hasLongTime = timelogsToCheck.some(timelog => {
                    return timelog.total_hours_normal > 600
                })
                if (hasLongTime) {
                    const shouldProceed = await new Promise(resolve => {
                        confirmAlert({
                            title: t('Confirm'),
                            message: t('Some of the selected timelogs exceed 10 hours. Are you sure you want to approve them?'),
                            buttons: [
                                { label: t('Yes'), onClick: () => resolve(true) },
                                { label: t('No'), onClick: () => resolve(false) }
                            ]
                        });
                    });

                    if (!shouldProceed) {
                        this.setState({ isLoading: false });
                        return;
                    }
                }
            }
            for (let i = 0; i < params.ids.length; i++) {
                currentId = params.ids[i];
                await timelogStore.setStatus(params.ids[i], params.entity, action, { notes: this.state.notes, admin_note: this.state.admin_note }, this.state.syncWithIntegration, shiftCreationParams, this.state.addedExtraPayment);
            }
            if ((action === 'rejected' || action === 'approved') && params.entity === 'timelog') {
                if (params.ids.length === 1) {
                    await timelogStore.singlePushNotification(params.ids[0], this.state.notes, action, false);
                } else {
                    await timelogStore.massPushNotification(params.ids, this.state.notes, action);
                }
            }
            afterSave();
            if (this.state.syncWithIntegration && !(params.entity === 'vacation' && this.currentIntegrationProduct === payrollIntegrationOptions.TRIPLETEX))
                commonStore.addNotification(t(`Syncing complete! The ${params.entity} is now synchronized with`) + " " + this.currentIntegrationProduct, null, 'success');
            else
                commonStore.addNotification(t('Saved'), null, 'success');
        } catch (err) {
            // A validation block (e.g. a medical leave that has to change together with the other
            // medical leaves of its employer period) comes back as a JSON body carrying userPrompts -
            // show that explanation instead of the generic "something went wrong".
            const userPrompt = err?.response?.body?.userPrompts?.[0];
            if (userPrompt) {
                this.setState({
                    userPromptModal: {
                        ...userPrompt,
                        actionMethods: {
                            handleCloseUserPromptModal: this.handleCloseUserPromptModal,
                            handleMedicalLeaveMassStatus: () => this.handleMedicalLeaveMassStatus(currentId, userPrompt.sourceInfo.medicalLeaveMassStatus, shiftCreationParams)
                        }
                    }
                });
            } else {
                commonStore.addNotification(t(typeof err === 'string' ? err : 'Something went wrong'), null, 'error');
            }
            console.error(err);
        }
        finally {
            this.setState({ isLoading: false })
        }
    }

    handleMedicalLeaveMassStatus = async (id, medicalLeaveMassStatus, shiftCreationParams) => {
        const { timelogStore, params, afterSave, commonStore, t } = this.props;
        this.setState({ isLoading: true })
        try {
            await timelogStore.setMedicalLeaveMassStatus(id, medicalLeaveMassStatus.action, medicalLeaveMassStatus.absences.map(absence => absence.id),
                { notes: this.state.notes, admin_note: this.state.admin_note }, this.state.syncWithIntegration, shiftCreationParams, this.state.addedExtraPayment);
            this.handleCloseUserPromptModal();
            afterSave();
            if (this.state.syncWithIntegration)
                commonStore.addNotification(t(`Syncing complete! The ${params.entity} is now synchronized with`) + " " + this.currentIntegrationProduct, null, 'success');
            else
                commonStore.addNotification(t('Saved'), null, 'success');
        } catch (err) {
            // The period changed since the prompt - the new list comes back to confirm. Any other
            // error closes the prompt; a payroll failure part way through also reloads the list,
            // since the leaves before it changed.
            const userPrompt = err?.response?.body?.userPrompts?.[0];
            if (userPrompt) {
                this.setState({
                    userPromptModal: {
                        ...userPrompt,
                        actionMethods: {
                            handleCloseUserPromptModal: this.handleCloseUserPromptModal,
                            handleMedicalLeaveMassStatus: () => this.handleMedicalLeaveMassStatus(id, userPrompt.sourceInfo.medicalLeaveMassStatus, shiftCreationParams)
                        }
                    }
                });
            } else {
                this.handleCloseUserPromptModal();
                if (err?.response?.body?.processedIds?.length) afterSave();
            }
            console.error(err);
        }
        finally {
            this.setState({ isLoading: false })
        }
    }

    handleCloseUserPromptModal = () => {
        this.setState({ userPromptModal: { ...this.state.userPromptModal, showModal: false } });
    }

    renderHistoryTable = () => {
        const { t } = this.props;
        const { integrationHistory } = this.state;
        const dateTimeRules = this.getDateTimeRules();

        if (!integrationHistory || !integrationHistory.length) {
            return <div className="p-3 text-center text-muted small">{t('No payroll history found!')}</div>;
        }

        return (
            <PayrollHistoryTable integrationSyncHistory={integrationHistory} dateTimeRules={dateTimeRules} />
        );
    };

    render() {
        if (this.state.isLoading)
            return <LoadingSpinner />;
        const { t, params, commonStore, userStore } = this.props;
        const { absenceExtraPaymentData, userDetail, employement_grade, integrationData, integrationStatus, entityUserId } = this.state;
        const width = params?.entity === 'absence' ? 10 : 0
        if (!params) return null;
        const dateTimeRules = this.getDateTimeRules();

        const { user_type, id: currentUserId } = userStore.currentUser;
        const preventPmSelfApproval = commonStore?.config?.client?.data?.basicRules?.preventPmSelfApproval;
        const allowMedicalLeaveSpliting = commonStore?.config?.client?.data?.basicRules?.allowMedicalLeaveSpliting;
        const isActivityBased = this.currentIntegrationProduct === payrollIntegrationOptions.XLEDGER || this.currentIntegrationProduct === payrollIntegrationOptions.TRIPLETEX;
        const isSelfApprovalBlocked = preventPmSelfApproval && user_type === 'pm' && parseInt(entityUserId) === parseInt(currentUserId);
        const selfApprovalMessage = t('You cannot approve, reject or reset your own request');
        return (
            <div>
                <div className="d-flex flex-row align-items-center w-100" style={{ gap: '1rem' }}>
                    {params.entity === 'timelog' && (
                        <div className="flex-grow-1">
                            <h3 className="modalAcceptCount px-3">
                                {t('Selected items')} <b>({params.count})</b>
                            </h3>
                            {(!!this.currentIntegrationProduct && !isNaN(params.count) && parseInt(params.count) > 5) &&
                                <>
                                    <div className='text-danger font-size-15 mb-2 px-3'>
                                        <span ><b>{t('Note')}:&nbsp;</b>
                                            {t('Syncing a large number of records may occasionally fail due to limitations in the payroll system. In such cases, please retry syncing individual records after some time.')}
                                        </span>
                                    </div>
                                </>
                            }
                        </div>
                    )}
                    {(params.entity === 'absence' || params.entity === 'vacation') && userDetail && (
                        <>
                            <div className="container-fluid">
                                <div className="row timelog-grid-time-card w-100">
                                    <Col
                                        xs={12}
                                        md={12}
                                        className="d-flex justify-content-between align-items-center p-2 card-timelog-grid-item"
                                    >
                                        <div className="d-flex align-items-left">
                                            <b>
                                                {userDetail.first_name} {userDetail.last_name}
                                            </b>
                                        </div>
                                        <b className="timelog-final-time-card-modal">
                                            {t('Remuneration type')} - {t(userDetail.payment_mode)}
                                        </b>
                                    </Col>
                                </div>

                                <div className="row timelog-grid-time-card mt-1 w-100 mb-2">
                                    <Col
                                        xs={12}
                                        md={6}
                                        className="d-flex justify-content-between align-items-center p-2 card-timelog-grid-item"
                                    >
                                        <div className="d-flex align-items-center">
                                            <b>{t('Leave Percentage (%)')}</b>
                                        </div>
                                        <b className="timelog-final-time-card-modal">{parseFloat(employement_grade).toFixed(2)}%</b>
                                    </Col>

                                    <Col
                                        xs={12}
                                        md={6}
                                        className="d-flex justify-content-between align-items-center p-2 card-timelog-grid-item"
                                    >
                                        <div className="d-flex align-items-center">
                                            <b>{t('Total Absence Hours')}</b>
                                        </div>
                                        <div className="d-flex align-items-center gap-2">
                                            <b className="timelog-final-time-card-modal">{Number(this.state.totalAbsenceHours.toFixed(2))}</b>
                                            {integrationStatus && (
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={
                                                        <Tooltip id="integration-status-tooltip" style={{
                                                            backgroundColor: integrationStatus === 'failed' ? '#dc3545' : '#4CAF50',
                                                            color: 'white',
                                                            whiteSpace: 'pre-wrap'
                                                        }}>
                                                            {integrationStatus === 'failed'
                                                                && this.formatIntegrationErrors(integrationData, this.currentIntegrationProduct)}
                                                            {integrationStatus === 'success' && this.formatIntegrationSuccess(integrationData, this.currentIntegrationProduct, integrationStatus)}
                                                            {integrationStatus === 'pending' && <div>{t('Absence Syncing Status')}: {t(integrationStatus).toUpperCase()}</div>}
                                                        </Tooltip>
                                                    }
                                                >
                                                    <i className={`fas fa-info-circle ${integrationStatus === 'failed' ? 'text-danger' : 'text-success'}`} />
                                                </OverlayTrigger>
                                            )}
                                            <b style={{ fontSize: '12px', textWrap: 'nowrap' }}>({minutesToTimeInput(this.state.start_time)} - {minutesToTimeInput(this.state.end_time)})</b>
                                        </div>
                                    </Col>
                                </div>
                            </div>
                        </>
                    )}
                </div>
                {absenceExtraPaymentData && absenceExtraPaymentData.length > 0 && (
                    <div className="timelog-array__right w-100">
                        <div className="border rounded" style={{ backgroundColor: '#fafafa' }}>
                            <div className="d-flex align-items-center justify-content-between px-2 py-1 border-bottom bg-white">
                                <span className="fw-semibold text-dark" style={{ fontSize: '12px' }}>
                                    {t('Extra Payments')} ({absenceExtraPaymentData.length})
                                </span>
                                {absenceExtraPaymentData.length > 1 && (
                                    <div className="form-check form-switch mb-0">
                                        <input
                                            type="checkbox"
                                            id="showMoreCheck"
                                            className="form-check-input"
                                            style={{ cursor: 'pointer' }}
                                            onChange={(e) => this.setState({ showMore: e.target.checked })}
                                        />
                                        <label
                                            htmlFor="showMoreCheck"
                                            className="form-check-label"
                                            style={{ fontSize: '11px', cursor: 'pointer' }}
                                        >
                                            Show all
                                        </label>
                                    </div>
                                )}
                            </div>

                            <div className="px-2 py-1">
                                <table className="table table-sm mb-0">
                                    <thead>
                                        <tr style={{ fontSize: '10px' }}>
                                            <th className="border-0 text-muted fw-normal" style={{ width: '45%' }}>
                                                {t('Additionals')} & {t('Date')}
                                            </th>
                                            <th className="border-0 text-muted fw-normal" style={{ width: '55%' }}>
                                                {t('Status')}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.handleExtraPaymentDisplay(absenceExtraPaymentData[0], 0)}

                                        {this.state.showMore &&
                                            absenceExtraPaymentData.length > 1 &&
                                            absenceExtraPaymentData
                                                .slice(1)
                                                .map((record, index) =>
                                                    this.handleExtraPaymentDisplay(record, index + 1)
                                                )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                )}

                {allowMedicalLeaveSpliting && this.state.absenceType === 'doctor' && this.state.currentStatus !== 'rejected' && !this.state.medicalLeaveSyncResult && (
                    <MedicalLeaveSyncTable
                        parts={this.state.medicalLeaveSyncPreview}
                        title={t('Medical leave will sync as')}
                        isActivityBased={isActivityBased}
                        defaultHolidaysExcluded={this.state.defaultHolidaysExcluded}
                        dateTimeRules={dateTimeRules}
                    />
                )}

                {allowMedicalLeaveSpliting && this.state.absenceType === 'doctor' && (
                    <MedicalLeaveSyncTable
                        parts={this.state.medicalLeaveSyncResult}
                        title={t('Medical leave synced as')}
                        showStatus
                        isActivityBased={isActivityBased}
                        defaultHolidaysExcluded={this.state.defaultHolidaysExcluded}
                        dateTimeRules={dateTimeRules}
                    />
                )}

                {!!(
                    this.state.shiftDetails?.length &&
                    (params.entity === 'vacation' || params.entity === 'absence')
                ) && (
                        <div className="timelog-array__right w-100">
                            <div>
                                {' '}
                                {`${t('This')} ${params.entity === 'absence' ? t('Absence') : t('Vacation')} ${t(
                                    'has intersecting shift(s) as listed below'
                                )}`}
                            </div>
                            {this.state.hasHolidays && (
                                <p className="small text-muted mt-2 mb-0">
                                    <strong className="text-dark">{t('Note')}:</strong>{' '}
                                    {t('Holiday shifts will not be displayed as they are already accounted in')}{' '}
                                    {params.entity === 'absence' ? t('Absence') : t('Vacation')}
                                </p>
                            )}
                            <Accordion allowZeroExpanded preExpanded={['shifts']} className="timelog_modal">
                                <AccordionItem title={
                                    <div style={{ margin: '-8px 0' }}>
                                        {t('Scheduled')} {t('shifts')}
                                    </div>
                                } uuid="shifts">
                                    <div className="table-scroll">
                                        <Table className="w-100 table-container">
                                            <thead>
                                                <tr className="w-100">
                                                    <th width={'20%'} style={{ textAlign: 'left' }}>
                                                        {t('Project')}
                                                    </th>
                                                    <th width={'20%'} style={{ textAlign: 'left' }}>{t('Task')}</th>
                                                    <th width={`${10}%`}>{t('Date')}</th>
                                                    <th width={`${20}%`}>{t('Time')}</th>
                                                    {params.entity === 'absence' && (
                                                        <th width={'30%'}>{t('Additionals')}</th>
                                                    )}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.shiftDetails?.map((ele, idx) => (
                                                    <tr key={idx} className="text-capitalize mt-1">
                                                        <td width={'25%'} className="">
                                                            <div className="d-flex align-items-left min-height-20 ps-2">
                                                                {ele.projectName}
                                                            </div>
                                                        </td>
                                                        <td
                                                            width={'25%'}
                                                            className="timelog_array_details"
                                                            style={{ textAlign: 'left' }}
                                                        >
                                                            {ele.taskName}
                                                        </td>
                                                        <td width={`${25 - width}%`} className="timelog_array_details">
                                                            {shortDateFormat(ele?.forDate, dateTimeRules)}
                                                        </td>
                                                        <td width={`${25 - width}%`} className="timelog_array_details">
                                                            <div className="d-flex flex-column">
                                                                <div className="timelog-date-text">{ele.title}</div>
                                                                {/* {params.entity === 'absence' && (
                                                                    <div className="timelog-time-text" style={{ fontSize: '9px' }}>({minutesToTimeInput(this.calculateAbsenceHours(ele.startTime, ele.endTime, ele.companyShiftId, employement_grade))}hrs) ({employement_grade}%)</div>
                                                                )} */}
                                                            </div>
                                                        </td>
                                                        {params.entity === 'absence' && (
                                                            <td width={'30%'} className="timelog_array_details">
                                                                {ele.extraPayments &&
                                                                    Object.entries(ele.extraPayments).length ? (
                                                                    <div>
                                                                        {Object.entries(ele.extraPayments).map(
                                                                            ([key, extra], index) => (
                                                                                <div style={{ lineHeight: '10px', fontSize: '9px' }} key={index}>
                                                                                    <div>{extra.name} :{' '}{extra?.extraPaymentType?.value === 'fixed_hourly_amount' || extra.code === 'shift_allowance' ? extra.value : minutesToTimeInput(extra.value)}</div>
                                                                                    <div>({employement_grade}%)</div>
                                                                                </div>
                                                                            )
                                                                        )}
                                                                    </div>
                                                                ) : (
                                                                    <span> - </span>
                                                                )}
                                                            </td>
                                                        )}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                </AccordionItem>
                            </Accordion>
                        </div>
                    )}

                {integrationStatus && (
                    <div className="timelog-array__right w-100 mt-2">
                        <div className="border rounded d-flex align-items-center justify-content-between px-2 py-1"
                            style={{ backgroundColor: integrationStatus === 'failed' ? '#f8d7da' : '#e9f7ef' }}>
                            <span className="fw-semibold" style={{ fontSize: '12px' }}>
                                {t('Payroll Sync Status')}: {t(integrationStatus).toUpperCase()}
                            </span>
                            {integrationStatus === 'success' &&
                                (() => {
                                    const wageTypeLabel = this.getWageTypeLabel(integrationData, this.currentIntegrationProduct);
                                    const isActivityBased = this.currentIntegrationProduct === payrollIntegrationOptions.XLEDGER || this.currentIntegrationProduct === payrollIntegrationOptions.TRIPLETEX;
                                    return wageTypeLabel ? <span style={{ fontSize: '12px' }}>{isActivityBased ? t('Activity') : t('Wage Type')}: {wageTypeLabel}</span> : null;
                                })()
                            }
                        </div>
                        {integrationStatus === 'failed' &&
                            <div className="text-danger" style={{ fontSize: '12px' }}>
                                {integrationData?.messages?.[0]?.message
                                    ? `${integrationData.messages[0].message} (${t('from')} ${this.currentIntegrationProduct})`
                                    : `${t('Something went wrong')} (${t('from')} ${this.currentIntegrationProduct})!`}
                                <br />
                                {t('Please reset and try again.')}
                            </div>
                        }
                    </div>
                )}
                {!!this.currentIntegrationProduct && (
                    this.currentIntegrationProduct === payrollIntegrationOptions.VISMA ||
                    (this.currentIntegrationProduct === payrollIntegrationOptions.TRIPLETEX && params.entity === 'absence') ||
                    (this.currentIntegrationProduct === payrollIntegrationOptions.XLEDGER)) && this.state.integrationHistory.length > 0 && (
                        <div className="timelog-array__right w-100 mt-2 mb-2">
                            <div className="border rounded" style={{ backgroundColor: '#fafafa' }}>
                                <div className="d-flex align-items-center justify-content-between px-2 py-1 border-bottom bg-white">
                                    <span className="fw-semibold text-dark" style={{ fontSize: '12px' }}>
                                        {t('Payroll')} {t('History')}
                                    </span>
                                </div>
                                {this.renderHistoryTable()}
                            </div>
                        </div>
                    )}
                {params.entity === 'absence' && this.currentIntegrationProduct !== payrollIntegrationOptions.XLEDGER &&
                    this.state.shiftDetails?.some(
                        (shift) => shift.extraPayments && Object.keys(shift.extraPayments).length > 0
                    ) && this.syncAdditionalPaymentsWithAbsence && (
                        <>
                            <div className="mt-2 d-flex justify-content-start mb-2 timelog-array__right w-100">
                                <div className="mt-1">
                                    <SwitchWidget
                                        value={this.state.addedExtraPayment}
                                        onChange={(checked) => this.handleExtraPaymentSwitch(checked)}
                                        disabled={this.isStatusUpdated() || (this.state.validationMessage === '' && !this.state.isAlreadySynced ? false : true)}
                                    />
                                </div>
                                <div>
                                    <label className="ml-10">{t(`Do you want to include additional payments?`)}</label>
                                </div>
                            </div>
                        </>
                    )}

                <Textarea
                    value={this.state.notes}
                    onChange={(e) => this.setState({ notes: e.target.value })}
                    placeholder={t('Comment')}
                    required
                    className="timelog-array__right w-100"
                />

                {!!this.currentIntegrationProduct &&
                    (params.entity === 'timelog' ||
                        this.currentIntegrationProduct === payrollIntegrationOptions.VISMA ||
                        (this.currentIntegrationProduct === payrollIntegrationOptions.TRIPLETEX && params.entity === 'absence') ||
                        (this.currentIntegrationProduct === payrollIntegrationOptions.XLEDGER)) && (
                        <div className="timelog-array__right w-100 mt-2">
                            {this.state.validationMessage &&
                                <span className='text-danger fw-bold font-size-12'>{t('Warning')}:&nbsp;{t(this.state.validationMessage)}</span>
                            }
                            <div className="d-flex align-items-center">
                                <div className="mt-1 mr-2">
                                    <SwitchWidget
                                        value={this.state.syncWithIntegration}
                                        onChange={(checked) => this.handleSyncSwitch(checked)}
                                        disabled={this.isStatusUpdated() || (this.state.validationMessage === '' && !this.state.isAlreadySynced ? false : true)}
                                    />
                                </div>
                                <label className="ml-10">{`${t(`Do You want to Save the hours to`)} ${this.currentIntegrationProduct
                                    }`}</label>
                            </div>
                        </div>
                    )}
                {!!this.currentIntegrationProduct &&
                    this.currentIntegrationProduct === payrollIntegrationOptions.TRIPLETEX &&
                    params.entity === 'vacation' && (
                        <div className="timelog-array__right w-100 mt-2 d-flex align-items-center">
                            <i className="fa fa-info-circle text-muted" aria-hidden="true" style={{ fontSize: '14px' }}></i>
                            <span className="text-muted ml-10" style={{ fontStyle: 'italic', fontSize: '13px' }}>
                                {t('Payroll sync is not supported for Vacation in Tripletex')}
                            </span>
                        </div>
                    )}
                <div className="timelog-modal-accept-buttons mt-20">
                    <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-approve">
                        {isSelfApprovalBlocked ? selfApprovalMessage :
                            this.isStatusUpdated() ? t('Please reset first to change approval status') : t('Approve')}
                    </Tooltip>}>
                        <Button
                            fill
                            dynamic_lg
                            style={{
                                backgroundColor: 'green',
                                border: 0,
                                opacity: !this.isStatusUpdated() && !isSelfApprovalBlocked ? '1' : '0.5',
                                color: 'white',
                            }}
                            disabled={this.isStatusUpdated() || isSelfApprovalBlocked}
                            onClick={() => this.handleRun('approved')}
                        >
                            <img src={ApprovalIcon} alt="ApprovalIcon" />
                            {t('Accept')}
                        </Button>
                    </OverlayTrigger>
                    <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-reject">
                        {isSelfApprovalBlocked ? selfApprovalMessage : this.isStatusUpdated() ? t('Please reset first to change approval status') : t('Reject')}
                    </Tooltip>}>
                        <Button
                            fill
                            dynamic_lg
                            style={{
                                backgroundColor: 'red',
                                border: 0,
                                opacity: !this.isStatusUpdated() && !isSelfApprovalBlocked ? '1' : '0.5',
                                color: 'white',
                            }}
                            onClick={() => this.handleRun('rejected')}
                            disabled={this.isStatusUpdated() || isSelfApprovalBlocked}
                        >
                            <img src={RejectIcon} alt="RejectIcon" />
                            {t('Reject')}
                        </Button>
                    </OverlayTrigger>
                    <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-reset">
                        {isSelfApprovalBlocked ? selfApprovalMessage : !this.isStatusUpdated() ? t('Pending approval') : t('Reset status')}
                    </Tooltip>}>
                        <Button
                            fill
                            dynamic_lg
                            style={{
                                backgroundColor: 'darkorange',
                                border: 0,
                                opacity: this.isStatusUpdated() && !isSelfApprovalBlocked ? '1' : '0.5',
                                color: 'white',
                            }}
                            onClick={() => this.handleRun('reset')}
                            disabled={!this.isStatusUpdated() || isSelfApprovalBlocked}
                        >
                            <img src={ResetApprovalIcon} alt="ResetApprovalIcons" /> {t('Reset')}
                        </Button>
                    </OverlayTrigger>
                </div>
                {this.state.userPromptModal.showModal && (
                    <UserPromptModal
                        source={this.state.userPromptModal.source}
                        header={this.state.userPromptModal.header}
                        showModal={this.state.userPromptModal.showModal}
                        sourceInfo={this.state.userPromptModal.sourceInfo}
                        actions={this.state.userPromptModal.actions}
                        actionMethods={this.state.userPromptModal.actionMethods}
                    />
                )}
            </div>
        );
    }
}
export default inject('timelogStore', 'absenceStore', 'commonStore', 'scheduleStore', 'vacationStore', 'clientStore', 'userStore'
)(applicationRouter(withLocalization(observer(AbsenceVacationApproval))));